export const serverSideGridMaxRowNum: number = 1000;